
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/answering-services/[answeringServicesPages]",
      function () {
        return require("private-next-pages/answering-services/[answeringServicesPages].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/answering-services/[answeringServicesPages]"])
      });
    }
  